
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getActualTargetAndSaldoFormGroup() {
return new FormGroup({
    actual: new FormControl<number | undefined>(undefined),
    target: new FormControl<number | undefined>(undefined),
    saldo: new FormControl<number | undefined>(undefined),
    planned: new FormControl<number | undefined>(undefined),
})
;
}
      